// Computes total entries from current cart state and persists it as a
// cart attribute. Mirrors the Liquid math in main-cart-footer / cart-drawer:
//   sum(item.properties[giveawayName] * item.quantity)
//   * booster multiplier (if a booster product is in cart)
//   + 1000 if shipping protection product is in cart
window.syncCartEntries = async function syncCartEntries() {
  const giveawayName = window.entries?.giveaway_name;
  if (!giveawayName) return null;

  try {
    const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartRes.ok) return null;
    const cart = await cartRes.json();

    let baseEntries = 0;
    let multiplier = 1;

    const boosters = window.booster || {};
    const boosterMap = new Map();
    if (boosters.booster_product_1?.id) boosterMap.set(boosters.booster_product_1.id, 2);
    if (boosters.booster_product_2?.id) boosterMap.set(boosters.booster_product_2.id, 5);
    if (boosters.booster_product_3?.id) boosterMap.set(boosters.booster_product_3.id, 10);
    if (boosters.booster_product_4?.id) boosterMap.set(boosters.booster_product_4.id, 25);
    if (boosters.booster_product_5?.id) boosterMap.set(boosters.booster_product_5.id, 50);

    for (const item of cart.items) {
      const raw = item.properties?.[giveawayName];
      const perUnit = parseInt(raw, 10);
      if (!Number.isNaN(perUnit)) {
        baseEntries += perUnit * item.quantity;
      }
      const boosterLevel = boosterMap.get(item.product_id);
      if (boosterLevel) multiplier = boosterLevel;
    }

    let totalEntries = baseEntries * multiplier;

    const sp = window.shippingProtection;
    if (sp?.status && sp?.product?.variant_id) {
      const spInCart = cart.items.some((i) => i.variant_id === sp.product.variant_id);
      if (spInCart) totalEntries += 1000;
    }

    const body = new FormData();
    body.append(`attributes[${giveawayName}]`, String(totalEntries));
    const updateRes = await fetch('/cart/update.js', { method: 'POST', body });
    if (!updateRes.ok) {
      console.warn('[entries-sync] update failed:', await updateRes.text());
      return null;
    }
    return totalEntries;
  } catch (e) {
    console.error('[entries-sync] error:', e);
    return null;
  }
};
